import { DEVICE_STORE_KEY, WebPlatform, parseStoredDevice, type StoredDevice } from "@helm/core";

/**
 * This browser's device id + secret (SPEC §20): lets the next sign-in re-attach to the same,
 * already-approved device instead of registering a new one. Kept in the platform store
 * (localStorage on the web; the OS keychain in native shells later).
 */
const store = new WebPlatform().secureStore;

export async function loadStoredDevice(): Promise<StoredDevice | null> {
  return parseStoredDevice(await store.get(DEVICE_STORE_KEY));
}

export async function saveStoredDevice(d: StoredDevice): Promise<void> {
  await store.set(DEVICE_STORE_KEY, JSON.stringify(d));
}

export async function clearStoredDevice(): Promise<void> {
  await store.delete(DEVICE_STORE_KEY);
}
